import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import AlignMenu from './AlignMenu';

const messages = defineMessages({
  align: {
    id: 'Allineamento',
    defaultMessage: 'Allineamento',
  },
});

const AlignButton = (props) => {
  const intl = useIntl();
  return <AlignMenu {...props} title={intl.formatMessage(messages.align)} />;
};

export default function install(config) {
  const { slate } = config.settings;

  slate.buttons.align = AlignButton;

  // The core renderLinkElement renders <Tag {...attributes} className={className}>
  // where className is a separate prop defaulting to null, which overrides
  // attributes.className. Since render.jsx puts element.styleName into
  // attributes.className, alignment classes are silently discarded on headings.
  // Override with simple renderers (same pattern as the core `p` element) so
  // attributes.className is spread correctly.
  ['h1', 'h2', 'h3', 'h4'].forEach((tag) => {
    const Tag = tag;
    slate.elements[tag] = ({ attributes, children }) => (
      <Tag {...attributes}>{children}</Tag>
    );
  });

  slate.toolbarButtons = ['align', 'separator', ...slate.toolbarButtons];
  slate.expandedToolbarButtons = [
    'align',
    'separator',
    ...slate.expandedToolbarButtons,
  ];

  return config;
}
